import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Grid, useMediaQuery } from '@material-ui/core'
import { useFetchPatientCopilotDataQuery } from 'store/modules/CopilotControl'
import CopilotCategoryTitle from '../CopilotCategoryTitle'
import ScanInsightsWidget from './ScanInsights/ScanInsightsWidget'
import PatientScanningScoreWidget from './PatientScanningScoreWidget'
import PatientSentimentWidget from './PatientSentimentWidget'
import ChatSummaryWidget from './ChatSummaryWidget'
import NotesSummaryWidget from './NotesSummaryWidget'

const CopilotInsights = () => {
  const { t } = useTranslation()

  const { patient } = useSelector(state => state.patientsReducer)
  const patientId = patient?.id
  const { data, isFetching } = useFetchPatientCopilotDataQuery(
    { patientId },
    { skip: !patientId, refetchOnMountOrArgChange: true }
  )
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('md'))

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <CopilotCategoryTitle>
          {t('pages.patients.patientSidebar.items.copilot.copilotInsights.title')}
        </CopilotCategoryTitle>
      </Grid>
      <Grid item style={{ marginBottom: '24px' }}>
        <Grid container direction={isSmallScreen ? 'column' : 'row'} spacing={1}>
          <Grid item style={{ flex: 1 }}>
            <ScanInsightsWidget isLoading={isFetching} latestScanTimelineItems={data?.timelineItems} />
          </Grid>
          <Grid item>
            <Grid container direction={isSmallScreen ? 'row' : 'column'} spacing={1}>
              <Grid item lg={12} md={6}>
                <PatientSentimentWidget
                  sentimentScore={data?.copilotData?.chatAnalysis?.sentimentScore}
                  sentimentReason={data?.copilotData?.chatAnalysis?.sentimentReason}
                  isLoading={isFetching}
                />
              </Grid>
              <Grid item lg={12} md={6}>
                <PatientScanningScoreWidget
                  scanningScheduleScoreCategory={data?.copilotData?.scanningScheduleScoreCategory}
                  isLoading={isFetching}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <ChatSummaryWidget
          chatSummary={data?.copilotData?.chatAnalysis?.chatSummary}
          isLoading={isFetching}
          updatedAt={data?.copilotData?.chatAnalysis?.updatedAt}
        />
      </Grid>
      <Grid item>
        <NotesSummaryWidget
          isLoading={isFetching}
          notesSummary={data?.copilotData?.notesAnalysis?.notesSummary}
          updatedAt={data?.copilotData?.notesAnalysis?.updatedAt}
        />
      </Grid>
    </Grid>
  )
}

export default CopilotInsights
